import { Box, FormControl, FormLabel, HStack, IconButton, Popover, PopoverBody, PopoverCloseButton, PopoverContent, PopoverTrigger, Stack, } from "@chakra-ui/react";
import React, { useState } from "react";
import { debounce } from "lodash";
import { useEffect, useMemo } from "react";
import { MdFormatAlignCenter, MdFormatAlignJustify, MdFormatAlignLeft, MdFormatAlignRight, MdFormatBold, MdFormatColorText, MdFormatItalic, MdFormatUnderlined, MdRedo, MdUndo, } from "react-icons/md";
import { CompactColorPicker, FontPicker, FontSizePicker, FormLabelStyle, } from "@govisupro/controls";
import { Editor, Transforms } from "slate";
import { HistoryEditor } from "slate-history";
import { useSlate } from "slate-react";
import { BlockButton, MarkButton, toggleMark } from "../../utils/slate";
const FontSizePickerComponent = ({ textData, onUpdate, itemScale = 1, }) => {
    var _a, _b;
    const editor = useSlate();
    const [selection, setSelection] = useState(null);
    const [fontSize, setFontSize] = useState(((_a = Editor.marks(editor)) === null || _a === void 0 ? void 0 : _a["fontSize"]) !== undefined
        ? Math.round(((_b = Editor.marks(editor)) === null || _b === void 0 ? void 0 : _b["fontSize"]) * itemScale)
        : // @ts-ignore
            Math.round(textData.text[0].children[0].fontSize * itemScale));
    useEffect(() => {
        var _a, _b;
        setFontSize(((_a = Editor.marks(editor)) === null || _a === void 0 ? void 0 : _a["fontSize"]) !== undefined
            ? Math.round(((_b = Editor.marks(editor)) === null || _b === void 0 ? void 0 : _b["fontSize"]) * itemScale)
            : // @ts-ignore
                Math.round(textData.text[0].children[0].fontSize * itemScale));
    }, [itemScale]);
    return (React.createElement(FontSizePicker, { fontSize: fontSize, setFontSize: setFontSize, onChange: (fontSize) => {
            var _a;
            toggleMark(editor, "fontSize", fontSize / itemScale);
            if (!selection)
                return;
            Transforms.select(editor, {
                anchor: selection.anchor,
                focus: selection.focus,
            });
            onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(Object.assign(Object.assign({}, textData), { text: (_a = editor.children) !== null && _a !== void 0 ? _a : textData.text }));
        }, onOpen: () => {
            if (!editor.selection)
                return;
            setSelection(editor.selection);
            Transforms.select(editor, {
                anchor: editor.selection.anchor,
                focus: editor.selection.focus,
            });
        } }));
};
export const ControlPanel = ({ layoutItem, onUpdate, loadedFonts, }) => {
    var _a, _b, _c, _d, _e, _f;
    const textData = layoutItem.widget.data;
    // const fontData = loadedFonts?.find((font) => font.name === textData.font);
    const updateTextData = useMemo(() => debounce((textData) => onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(textData), 300), [layoutItem, onUpdate]);
    const editor = useSlate();
    const [backgroundColor, setBackgroundColor] = useState(textData.backgroundColor);
    useEffect(() => {
        if (textData.backgroundColor === backgroundColor)
            return;
        updateTextData(Object.assign(Object.assign({}, textData), { backgroundColor }));
    }, [backgroundColor]);
    useEffect(() => {
        return () => {
            updateTextData.cancel();
        };
    }, []);
    return (React.createElement(Stack, { key: `control-panel-${layoutItem.id}`, gap: 2, width: "100%" },
        React.createElement(HStack, { spacing: 2 },
            React.createElement(FormControl, null,
                React.createElement(FormLabel, Object.assign({ htmlFor: "letter-spacing" }, FormLabelStyle), "Actions"),
                React.createElement(HStack, null,
                    React.createElement(IconButton, { size: "sm", "aria-label": "Annuler", icon: React.createElement(MdUndo, null), onMouseDown: (e) => {
                            e.preventDefault();
                            HistoryEditor.undo(editor);
                        } }),
                    React.createElement(IconButton, { size: "sm", "aria-label": "R\u00E9tablir", icon: React.createElement(MdRedo, null), onMouseDown: (e) => {
                            e.preventDefault();
                            HistoryEditor.redo(editor);
                        } }))),
            React.createElement(CompactColorPicker, { id: "background", label: "Fond ", color: backgroundColor, onChange: (backgroundColor) => setBackgroundColor(backgroundColor), minimized: true })),
        React.createElement(FormControl, null,
            React.createElement(FormLabel, Object.assign({}, FormLabelStyle), "Police"),
            React.createElement(Stack, { direction: "row" },
                React.createElement(Box, { flex: 1 },
                    React.createElement(FontPicker, { selectedFont: (_b = (_a = Editor.marks(editor)) === null || _a === void 0 ? void 0 : _a["font"]) !== null && _b !== void 0 ? _b : "Poppins", fonts: loadedFonts || [], onSelect: (fontName) => {
                            var _a;
                            toggleMark(editor, "font", fontName);
                            onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(Object.assign(Object.assign({}, textData), { text: (_a = editor.children) !== null && _a !== void 0 ? _a : textData.text }));
                        } })),
                React.createElement(FontSizePickerComponent, { textData: textData, onUpdate: onUpdate, itemScale: layoutItem.scale }))),
        React.createElement(FormControl, null,
            React.createElement(FormLabel, Object.assign({}, FormLabelStyle), "Alignement"),
            React.createElement(Stack, { direction: "row" },
                React.createElement(BlockButton, { format: "left", icon: React.createElement(MdFormatAlignLeft, null) }),
                React.createElement(BlockButton, { format: "center", icon: React.createElement(MdFormatAlignCenter, null) }),
                React.createElement(BlockButton, { format: "right", icon: React.createElement(MdFormatAlignRight, null) }),
                React.createElement(BlockButton, { format: "justify", icon: React.createElement(MdFormatAlignJustify, null) }))),
        React.createElement(FormControl, null,
            React.createElement(FormLabel, Object.assign({}, FormLabelStyle), "Typographie"),
            React.createElement(Stack, { direction: "row" },
                React.createElement(MarkButton, { format: "bold", icon: React.createElement(MdFormatBold, null) }),
                React.createElement(MarkButton, { format: "italic", icon: React.createElement(MdFormatItalic, null) }),
                React.createElement(MarkButton, { format: "underline", icon: React.createElement(MdFormatUnderlined, null) }),
                React.createElement(Popover, null,
                    React.createElement(PopoverTrigger, null,
                        React.createElement(IconButton, { size: "sm", "aria-label": "Couleur du texte", icon: React.createElement(MdFormatColorText, null) })),
                    React.createElement(PopoverContent, { p: 2 },
                        React.createElement(PopoverCloseButton, null),
                        React.createElement(PopoverBody, null,
                            React.createElement(Stack, { gap: 2 },
                                React.createElement(CompactColorPicker, { label: "Couleur du text", id: "textColor", color: (_d = (_c = Editor.marks(editor)) === null || _c === void 0 ? void 0 : _c["color"]) !== null && _d !== void 0 ? _d : "#FFFFFF", onChange: (newColor) => {
                                        var _a;
                                        toggleMark(editor, "color", newColor);
                                        onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(Object.assign(Object.assign({}, textData), { text: (_a = editor.children) !== null && _a !== void 0 ? _a : textData.text }));
                                    } }),
                                React.createElement(CompactColorPicker, { label: "Couleur de l'arri\u00E8re plan", id: "backgroundTextColor", color: (_f = (_e = Editor.marks(editor)) === null || _e === void 0 ? void 0 : _e["backgroundColor"]) !== null && _f !== void 0 ? _f : "#FFFFFFFF", onChange: (newColor) => {
                                        var _a;
                                        toggleMark(editor, "backgroundColor", newColor);
                                        onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(Object.assign(Object.assign({}, textData), { text: (_a = editor.children) !== null && _a !== void 0 ? _a : textData.text }));
                                    } })))))))));
};
